export { default } from './request-equipment-service-equipment-info';
